module.exports = __webpack_public_path__ + "img/logo.792123cc.jpg";